import { defineStore } from "pinia";
import { getPresetLists } from '@/static/preset-lists';

const initialState: AppState = {
  initialized: false,

  presetLists: [],
};

export const useAppStore = defineStore('app', {
  state: () => initialState,

  actions: {
    async init() {
      await this.getAndSetPresetLists();
    },

    async getConceptList() {
      let conceptList: Concept[] = [];

      try {
        const allConceptsResponse = await fetch('data/all-concepts.json');

        const customConceptsResponse = await fetch('data/custom-concepts.json');

        if (allConceptsResponse.ok && customConceptsResponse.ok) {
          const rawDataAllConcepts: Concept[] = await allConceptsResponse.json();
          const rawDataCustomConcepts: Concept[] = await customConceptsResponse.json();

          const rawData = [...rawDataAllConcepts, ...rawDataCustomConcepts];

          const processedData = rawData.map(c => {
            const { inProfiles = [] } = c;

            c.profile = inProfiles[0] || {};

            c.inMyList = false;
            c.notes = '';

            delete c.inProfiles;

            return c;
          });

          conceptList = processedData;
          // this.conceptList = processedData;

        } else {
          console.error('Unknown error getting concept list', allConceptsResponse);
        }
      } catch (error) {
        console.error('error getting concept list:', error);
      }

      return conceptList;
    },

    async getAndSetPresetLists() {
      try {
        this.presetLists = await getPresetLists();
      } catch (error) {
        console.error('error getting presets:', error);
      }
    },
  }
});